/**
 *    @author: Andrew Sheen
 *    @since:  2021-01-08
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {TranslateModule} from "@ngx-translate/core";

//import { ProgressComponent } from './layout/progress/progress.component';

import {HttpClientModule} from "@angular/common/http";
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';


import { AccordionComponent } from './layout/accordion/accordion.component';
import { DropdownComponent } from './form-control/dropdown/dropdown.component';
import { CheckboxComponent } from './form-control/checkbox/checkbox.component';
import { InputComponent } from './form-control/input/input.component';
import { InputDateComponent } from './form-control/input-date/input-date.component';
import { RadioComponent } from './form-control/radio/radio.component';
import { Radio1Component } from './form-control/radio1/radio1.component';

import { InformationComponent } from './layout/information/information.component';
import { NoticeBoxComponent }   from './layout/notice-box/notice-box.component';
import { ErrorsComponent }   from './layout/errors/errors.component';
import { LinkComponent }   from './layout/link/link.component';
import { HeaderXComponent }   from './layout/header-x/header-x.component';
import { LightBox }   from './layout/light-box/light-box.component';

import { AltTextDirective } from './layout/attribute/altText.directive';
import { HtmlDirective } from './layout/attribute/html.directive';
import { UpdateDirective } from './layout/attribute/update.directive';
import { CurrFormatPipe } from './service/CurrencyFormat';


@NgModule({
  declarations: [
    //ErrorComponent,
    HeaderComponent,
    FooterComponent,      
                              //  ProgressComponent,
    AccordionComponent,
    DropdownComponent,
    CheckboxComponent,
    InputComponent,
    InputDateComponent,
    RadioComponent,
    Radio1Component,
    InformationComponent,
    NoticeBoxComponent,
    AltTextDirective,
    HtmlDirective,
    UpdateDirective,
    LinkComponent,
    HeaderXComponent,
    LightBox,
    ErrorsComponent,
    CurrFormatPipe
],
  imports: [
      CommonModule,
      FormsModule,
      TranslateModule,
      RouterModule,
      HttpClientModule
    ],
    exports: [HeaderComponent,
              FooterComponent,             
                                //    ProgressComponent,

              AccordionComponent,
              InformationComponent,
              NoticeBoxComponent,

              DropdownComponent,
              CheckboxComponent,
              InputComponent,
              InputDateComponent,
              RadioComponent,
              Radio1Component,
              AltTextDirective,
              HtmlDirective,
              UpdateDirective,
              LinkComponent,
              ErrorsComponent,
              HeaderXComponent,
              LightBox,
              CurrFormatPipe,

              CommonModule,FormsModule,HttpClientModule]
})
export class RefreshModule {}
